<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<!-- <livechat-widget 
  license="17708787"
  visibility="minimized"
  [customerEmail]="userEmail$|async"
  [customerName]="userName$|async"
  [customIdentityProvider]="livechatService.getIdentityProvider()"
  (onReady)="onLiveChatReady()"></livechat-widget> -->

<button class="ticket-btn" (click)="onTicket()">
  <mat-icon inline>help</mat-icon>
  Get Help
</button>
<router-outlet></router-outlet>
